module.exports = __webpack_public_path__ + "static/media/gloves.7b598af2.png";